import { all, call, put, takeLatest } from 'redux-saga/effects'

import { api } from '../../services'

import {
  loadCmsJobs,
  loadCmsJobsFailure,
  loadCmsJobsSuccess
} from './actions'

export function * requestCmsJobs ({ payload: searchParams }) {
  const requestParams = {
    ...searchParams,
    offset: 0,
    limit: 2
  }

  try {
    const {
      data: {
        data: results,
        resultSize
      }
    } = yield call(api.search.job, requestParams)
    yield put(loadCmsJobsSuccess(results, { resultSize }))
  } catch (e) {
    yield put(loadCmsJobsFailure(e.message || e))
  }
}

export default all([
  takeLatest(loadCmsJobs, requestCmsJobs)
])
